import { Alert, AlertTitle, Box, Button, Card, CardContent, CardHeader, CircularProgress, Divider, Typography, styled, useTheme } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2"
import { motion } from "framer-motion"
import React, { forwardRef, useContext, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { aprobadasPendientesLiquidacion, aprobarRechazarLiquidacion, liquidadas, novedadesEmpleados, pendientesAprobacion, solicitarLiquidacion } from "../Redux/novedadesLiquidacion"
import { COLUMNSAPROBADASPENDIENTES, COLUMNSLIQUIDADAS, COLUMNSPENDIENTEAPROBACION, COLUMNSSOLICITUDESEMPLEADOS } from "../columnas/columnaLiquidacion"
import { UserAuth } from "../context/AuthContext"
import TokenContext from "../context/TokenContext"
import Header from "./Header"
import Tabla from "./Tabla"
import ModalAprobacionRechazoPago from "./modales/ModalAprobacionRechazoPago"
import ModalSolicitudLiquidacion from "./modales/ModalSolicitudLiquidacion"
import TablaLiquidaciones from "./tablas/TablaLiquidaciones"
import moment from "moment/moment"
import { useLocation } from "react-router-dom"
import { analytics } from '../Firebase'
import TablaVacaciones from "./tablas/TablaVacaciones"
import useUsuario from "./hooks/useUsuario"

const NovedadesLiquidacion = () => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const token = useContext(TokenContext)
  const { empleado } = UserAuth()
  const { usuarioAutor } = useUsuario();
  
  const location = useLocation();
  const [openLiquidacion, setOpenLiquidacion] = useState(false)

  const [openModalAprobacion, setOpenModalAprobacion] = React.useState(false)
  const [idLiquidacion, setIdLiquidacion] = React.useState("")

  const pendientesAproSelector = useSelector((store) => store.novedadesLiquidacion.pendientesAprobacion)
  const getPendientesAprobacionSelector = useSelector((store) => store.novedadesLiquidacion.getPendientesAprobacion)
  const [getPendientesAprobacion, setGetPendientesAprobacion] = React.useState(false)
  const [pendientesAprob, setPendientesAprob] = React.useState([])

  const aprobPendSelector = useSelector((store) => store.novedadesLiquidacion.AprobadasPendientesLiquidacion)
  const getPendientesLiquidacionSelector = useSelector((store) => store.novedadesLiquidacion.getPendientesLiquidacion)
  const [getPendientesLiquidacion, setGetPendientesLiquidacion] = React.useState(false)
  const [aprobPendienteLiqui, setAprobPendienteLiqui] = useState([])

  const liquidadasSelector = useSelector((store) => store.novedadesLiquidacion.liquidadas)
  const getLiquidadasSelector = useSelector((store) => store.novedadesLiquidacion.getLiquidadas)
  const [getLiquidadas, setGetLiquidadas] = React.useState(false)
  const [aprobLiquidadas, setAprobLiquidadas] = useState([])

  const [licenciasEmpleados, setLicenciasEmpleados] = useState([])
  const licEmpSelector = useSelector(store => store.novedadesLiquidacion.novedadesEmp)

  const [selectedId, setSelectedId] = useState(null);

  React.useEffect(() => {
    if (empleado && empleado.usuarioPortalRh) {
      // Extraer el nombre de usuario de la dirección de correo electrónico
      const userEmail = empleado.usuarioPortalRh;
      const userName = userEmail.split('@')[0];

      // Enviar el evento a Firebase Analytics con el nombre de usuario
      analytics.logEvent('screen_view', {
        screen_name: location.pathname,
        user_email: userName,
      });
    }
  }, [empleado, location]);

  useEffect(() => {
    if (token && Object.keys(empleado).length > 0) {
      dispatch(pendientesAprobacion(token, empleado.usuarioPortalRh))
      dispatch(aprobadasPendientesLiquidacion(token, empleado.usuarioPortalRh))
      dispatch(liquidadas(token, empleado.usuarioPortalRh))
      dispatch(novedadesEmpleados(token, empleado.empleadoid))
    }
  }, [token, empleado])

  useEffect(() => {
    if (licEmpSelector.length > 0) {
      const newArray = licEmpSelector.map((element) => ({
        id: element.new_empleadoid,
        new_name: element.new_name,
        new_numerolegajo: element.new_numerolegajo,
      }))
      setLicenciasEmpleados(newArray)
    }
  }, [licEmpSelector])

  useEffect(() => {
    if (pendientesAproSelector?.length > 0 && getPendientesAprobacionSelector) {
      const pendientesApro = []
      pendientesAproSelector.forEach((items) => {
        const obj = {
          id: items.new_novedadid,
          fecha: moment(items["createdon"], "YYYY-MM-DD").format("DD/MM/YY"),
          empleado: items["_new_empleado_value@OData.Community.Display.V1.FormattedValue"],
          fechaNovedad: items["new_fechadenovedad@OData.Community.Display.V1.FormattedValue"],
          tipoNovedadPago: items["_new_tipodenovedaddepago_value@OData.Community.Display.V1.FormattedValue"],
          tipoNovedad: items["new_tipodenovedad@OData.Community.Display.V1.FormattedValue"],
          tipoNovedadPagoSelect: { label: items["_new_tipodenovedaddepago_value@OData.Community.Display.V1.FormattedValue"], value: items._new_tipodenovedaddepago_value },
          tipoNovedadSelect: { label: items["new_informa@OData.Community.Display.V1.FormattedValue"], value: items["new_informa"] },
          divisa: { value: items["_transactioncurrencyid_value"], label: items["_transactioncurrencyid_value@OData.Community.Display.V1.FormattedValue"] },
          estado: items["statuscode"],
          cantidadHoras: items["new_cantidadhoras"],
          aprobadorId: items["_new_aprobador_value"],
        }
        pendientesApro.push(obj)
      })
      setPendientesAprob(pendientesApro)
      setGetPendientesAprobacion(getPendientesAprobacionSelector)
    } else if (pendientesAproSelector?.length === 0 && getPendientesAprobacionSelector) {
      setGetPendientesAprobacion(getPendientesAprobacionSelector)
      setPendientesAprob([])
    }
  }, [pendientesAproSelector, getPendientesAprobacionSelector])

  useEffect(() => {
    if (aprobPendSelector?.length > 0 && getPendientesLiquidacionSelector) {
      const aprobPendientesLiqui = []
      aprobPendSelector.forEach((items) => {
        const obj = {
          id: items.new_novedadid,
          fecha: items["new_fechadeaprobacin@OData.Community.Display.V1.FormattedValue"],
          empleado: items["_new_empleado_value@OData.Community.Display.V1.FormattedValue"],
          tipoNovedad: items["new_tipodenovedad@OData.Community.Display.V1.FormattedValue"],
          informa: items["new_informa@OData.Community.Display.V1.FormattedValue"],
          estado: items["statuscode"]
        }
        aprobPendientesLiqui.push(obj)
      })
      setAprobPendienteLiqui(aprobPendientesLiqui)
      setGetPendientesLiquidacion(getPendientesLiquidacionSelector)
    } else if (aprobPendSelector?.length === 0 && getPendientesLiquidacionSelector) {
      setGetPendientesLiquidacion(getPendientesLiquidacionSelector)
      setAprobPendienteLiqui([])
    }
  }, [aprobPendSelector, getPendientesLiquidacionSelector])

  useEffect(() => {
    if (liquidadasSelector?.length > 0 && getLiquidadasSelector) {
      const aprobLiquidadas = []
      liquidadasSelector.forEach((items) => {
        const obj = {
          id: items.new_novedadid,
          fechaLiquidacion: items["new_fechaliquidacin@OData.Community.Display.V1.FormattedValue"],
          empleado: items["_new_empleado_value@OData.Community.Display.V1.FormattedValue"],
          tipoNovedad: items["_new_tipodenovedaddepago_value@OData.Community.Display.V1.FormattedValue"],
          estado: items["statuscode"]
        }
        aprobLiquidadas.push(obj)
      })
      setAprobLiquidadas(aprobLiquidadas)
      setGetLiquidadas(getLiquidadasSelector)
    } else if (liquidadasSelector?.length === 0 && getLiquidadasSelector) {
      setGetLiquidadas(getLiquidadasSelector)
      setAprobLiquidadas([])
    }
  }, [liquidadasSelector, getPendientesLiquidacionSelector])


  const handleOpenModal = (id, lineas) => {
    if (id) {
      setOpenModalAprobacion(true)
      setIdLiquidacion(id)
    }
  }

  const handleOpenLiquidacion = (id = null) => {
    setOpenLiquidacion(true);
    setSelectedId(id);
  };

  const handleCloseLiquidacion = () => {
    setOpenLiquidacion(false);
    setSelectedId(null); // Limpiar el id seleccionado cuando se cierra el modal
  };


  const handleCloseModalAprobacion = () => setOpenModalAprobacion(false)

  const handleSubmit = (datos) => {
    if (selectedId) {
      dispatch(solicitarLiquidacion(token, datos, selectedId, usuarioAutor ? usuarioAutor.id : null))
        .then((id) => {
          handleCloseLiquidacion()
          dispatch(pendientesAprobacion(token, empleado.usuarioPortalRh))
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      dispatch(solicitarLiquidacion(token, datos, empleado.empleadoid, usuarioAutor ? usuarioAutor.id : null))
        .then((id) => {
          handleCloseLiquidacion()
          dispatch(pendientesAprobacion(token, empleado.usuarioPortalRh))
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }

  }

  const handleSubmitAprobacion = async (datos) => {
    try {
      const id = await dispatch(aprobarRechazarLiquidacion(token, datos));
      if (id?.length > 0) {
        handleCloseModalAprobacion();
        await new Promise((resolve) => setTimeout(resolve, 4500));
        await Promise.all([
          dispatch(pendientesAprobacion(token, empleado.usuarioPortalRh)),
          dispatch(aprobadasPendientesLiquidacion(token, empleado.usuarioPortalRh)),
        ]);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };



  // ==============================|| CUSTOM MAIN CARD ||============================== //
  // constant
  const headerSX = {
    "& .MuiCardHeader-action": { mr: 0 },
  }

  const MainCard = forwardRef(
    (
      {
        border = true,
        boxShadow,
        children,
        content = true,
        contentClass = "",
        contentSX = {},
        darkTitle,
        secondary,
        shadow,
        sx = {},
        title,
        ...others
      },
      ref
    ) => {
      const theme = useTheme()

      return (
        <Card
          ref={ref}
          {...others}
          sx={{
            border: border ? "1px solid" : "none",
            borderColor: theme.palette.primary[200] + 25,
            ":hover": {
              boxShadow: boxShadow ? shadow || "0 2px 14px 0 rgb(32 40 45 / 8%)" : "inherit",
            },
            ...sx,
          }}
        >
          {/* card header and action */}
          {title && <CardHeader sx={headerSX} title={darkTitle ? <Typography variant="h3">{title}</Typography> : title} action={secondary} />}

          {/* content & header divider */}
          {title && <Divider />}

          {/* card content */}
          {content && (
            <CardContent sx={contentSX} className={contentClass}>
              {children}
            </CardContent>
          )}
          {!content && children}
        </Card>
      )
    }
  )

  const CardWrapper = styled(MainCard)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.tertiary[600],
    color: theme.palette.primary.light,
    overflow: "hidden",
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      width: 210,
      height: 210,
      background: `linear-gradient(210.04deg, ${theme.palette.primary[200]} -50.94%, rgba(144, 202, 249, 0) 83.49%)`,
      borderRadius: "50%",
      top: -30,
      right: -180,
    },
    "&:before": {
      content: '""',
      position: "absolute",
      width: 210,
      height: 210,
      background: `linear-gradient(140.9deg, ${theme.palette.primary[200]} -14.02%, rgba(144, 202, 249, 0) 77.58%)`,
      borderRadius: "50%",
      top: -160,
      right: -130,
    },
  }))
  // ====================================================================================== //

  return (
    <motion.div
      initial={{ opacity: 0, y: 100 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -100 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      <Box m="1rem 2.5rem">
        <Header title={"Novedades por liquidación"} subtitle={empleado && empleado.habilitadoNovedad ? "En esta sección podrás solicitar una liquidación." : "No estas autorizado para visualizar este contenido"} />
        {empleado && empleado.habilitadoNovedad ? (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} sx={{ mt: 4 }}>
                <TablaVacaciones
                  columnas={COLUMNSSOLICITUDESEMPLEADOS}
                  lineas={licenciasEmpleados}
                  handleOpen={handleOpenLiquidacion}
                  acciones={true}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="h5" color={theme.palette.secondary[50]} fontWeight="bold" sx={{ mb: "5px" }}>
                    Pendientes de aprobación
                  </Typography>
                </Box>
                {!getPendientesAprobacion ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "100%",
                      py: 2,
                    }}
                  >
                    <CircularProgress color="secondary" />
                  </Box>
                ) : pendientesAprob.length > 0 ? (
                  <Tabla columnas={COLUMNSPENDIENTEAPROBACION} lineas={pendientesAprob} handleOpen={handleOpenModal} acciones={true} />
                ) : (
                  <Alert severity="info">
                    <AlertTitle>Info</AlertTitle>
                    Aún no tienes registros de <strong>Pendientes de aprobación</strong>.
                  </Alert>
                )}
              </Grid>
              <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="h5" color={theme.palette.secondary[50]} fontWeight="bold" sx={{ mb: "5px" }}>
                    Aprobadas pendientes de liquidación
                  </Typography>
                </Box>
                {!getPendientesLiquidacion ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "100%",
                      py: 2,
                    }}
                  >
                    <CircularProgress color="secondary" />
                  </Box>
                ) : aprobPendienteLiqui.length > 0 ? (
                  <TablaLiquidaciones columnas={COLUMNSAPROBADASPENDIENTES} lineas={aprobPendienteLiqui} />
                ) : (
                  <Alert severity="info">
                    <AlertTitle>Info</AlertTitle>
                    Aún no tienes registros de <strong>Aprobadas pendientes de liquidación</strong>.
                  </Alert>
                )}
              </Grid>

              <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="h5" color={theme.palette.secondary[50]} fontWeight="bold" sx={{ mb: "5px" }}>
                    Liquidadas
                  </Typography>
                </Box>
                {!getLiquidadas ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "100%",
                      py: 2,
                    }}
                  >
                    <CircularProgress color="secondary" />
                  </Box>
                ) : aprobLiquidadas.length > 0 ? (
                  <TablaLiquidaciones columnas={COLUMNSLIQUIDADAS} lineas={aprobLiquidadas} />
                ) : (
                  <Alert severity="info">
                    <AlertTitle>Info</AlertTitle>
                    Aún no tienes registros de <strong>Liquidadas</strong>.
                  </Alert>
                )}
              </Grid>
            </Grid>
          </>
        ) : null}

      </Box>
      {openLiquidacion && <ModalSolicitudLiquidacion open={openLiquidacion} handleClose={handleCloseLiquidacion} onSubmit={handleSubmit} />}
      {openModalAprobacion && (
        <ModalAprobacionRechazoPago
          open={openModalAprobacion}
          handleClose={handleCloseModalAprobacion}
          liquidacion={pendientesAprob.find((item) => item.id === idLiquidacion)}
          onSubmit={handleSubmitAprobacion}
        />
      )}
    </motion.div>
  )
}

export default NovedadesLiquidacion
